import { IClient } from './../client/reducers/client.reducers';

export interface IClientState {
    clientGroups: IClient[];
    selectedClientGroup: IClient;
    selectedClientName: string;
    needClientBeSelected: boolean;
    doesDefaultClientListExist: boolean;
    selectedDate: Date;
    isEntityDateDataUpdated: boolean;
    multiSelect: boolean;
    loading: boolean;
    error: boolean;
    errorMessage: string;
    availablePositions: any[];
}

export const initialClientState: IClientState = {
    clientGroups: null,
    selectedClientGroup: {
        GroupId: 0,
        GroupName: '',
        Members: []
    },
    selectedClientName: '',
    needClientBeSelected: false,
    doesDefaultClientListExist: false,
    selectedDate: null,
    isEntityDateDataUpdated: false,
    multiSelect: false,
    loading: false,
    error: false,
    errorMessage: '',
    availablePositions: []
};
